module.exports = __webpack_public_path__ + "img/ADpt.e11a83df.svg";